module.exports = __webpack_public_path__ + "img/washer.2e4db30f.png";